import { useMutation } from '@tanstack/react-query'

import { errorToast } from 'common/components/toastNotification'
import { Tag } from 'common/interfaces/tags'

import { createTag } from '..'

const useCreateTagMutation = () => {
  return useMutation<Tag, unknown, { tag: string; userId: string }>({
    mutationFn: ({ tag, userId }) => createTag({ tag, userId }),
    onError: () => {
      errorToast('Something went wrong. Please try again.')
    },
  })
}

export default useCreateTagMutation
